import React from 'react';

class ModalView extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      isActive: this.props.isActive
    }
  }

  onClose () {
    this.setState({
      isActive: false
    });

    this.props.onClose();
  }

  render () {
    if (this.state.isActive) {
      return (
        <div className={'modal ' + this.props.size} onClick={(e) => e.stopPropagation()}>
          {this.props.children}
        </div>
      )
    }
    else {
      return false;
    }
  }
}

ModalView.defaultProps = {
  size: 'medium',
  onClose: () => {}
}

export default ModalView;



/** WEBPACK FOOTER **
 ** ./modules/shared/modal_view.js
 **/